module.exports = __webpack_public_path__ + "img/noActivityIcon.50eb8e54.svg";